import { readPdfObjects } from "./pdf-objects"
import { readGeoMeasure } from "./geo-measure"
import { projectPageCorners } from "./page-corners"

export const parseGeospatialPdfCorners = async (pdf: Uint8Array) => {
    const measure = readGeoMeasure(await readPdfObjects(pdf))
    return measure && projectPageCorners(measure)
}
